export function getProfileInitials(email, displayName) {
  if (displayName?.trim()) {
    return displayName.trim()[0].toUpperCase();
  }

  if (!email) return 'A';

  const localPart = email.split('@')[0] || '';
  const firstName = localPart.split(/[._-]/).filter(Boolean)[0] || localPart;
  return (firstName[0] || 'A').toUpperCase();
}
